const triggers = []

export default triggers
